import { getStore } from '../../store';
import ACTIONS from './actions';

import * as ProgramTypes from '../calendar/programTypes';
import * as authorization from '../../../lib/authorization';
import SegmentService from '../../../lib/segment/SegmentService';

export const disableCalendarHeader = () => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_HEADER_TOGGLE,
        enabled: false
    });
};

export const disableDesignerHeader = () => {
    getStore().dispatch({
        type: ACTIONS.DESIGNER_HEADER_TOGGLE,
        enabled: false
    });
};

export const enableCalendarHeader = () => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_HEADER_TOGGLE,
        enabled: true
    });
};

export const enableDesignerHeader = () => {
    getStore().dispatch({
        type: ACTIONS.DESIGNER_HEADER_TOGGLE,
        enabled: true
    });
};

export const redirectToTypeList = type => {
    switch (type) {
        case ProgramTypes.TYPES.FIXED:
            return (window.location = authorization.navigateToLibrary.path);
        case ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR:
        case ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR:
            return (window.location = authorization.navigateToAthletes.path);
        default:
            return (window.location = authorization.navigateToTeams.path);
    }
};

export const setPath = (location, computedMatch) => {
    getStore().dispatch({
        type: ACTIONS.NAV_SET_PATH,
        path: location
    });
    SegmentService.page(location, computedMatch);
};
